<template>
  <div id="concept" class="page">
    <section class="faq-pg-section section-padding-50 bg-grey">
      <div class="container">
        <div class="row">
          <div class="col-md-12 text-center">
            <h1>Composez un garde-corps <div>au design UNIQUE</div></h1>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="service-s2-box-grids">
              <div class="grid">
                <div class="inner">
                  <h3><span class="num">4</span>Poteaux</h3>
                  <ul class="tags">
                    <li><a href="#">Inox 304</a></li>
                    <li><a href="#">Inox 316</a></li>
                  </ul>
                  <p>Ils délimitent votre garde-corps et se posent à l'anglaise ou à la française suivant vos envies.</p>
                  <img src="/static/images/concept/poteaux.jpg" alt="">
                </div>
              </div>
              <div class="grid">
                <div class="inner">
                  <h3><span class="num">5</span>Rambardes</h3>
                  <ul class="tags">
                    <li><a href="#">Inox</a></li>
                    <li><a href="#">Bois</a></li>
                  </ul>
                  <p>2 design différents pour finaliser votre rampe de garde-corps. En bois ou en inox.</p>
                  <img src="/static/images/concept/rambarde.jpg" alt="">
                </div>
              </div>
              <div class="grid">
                <div class="inner">
                  <h3><span class="num">3</span>Remplissage</h3>
                  <ul class="tags">
                    <li><a href="#">câbles</a></li>
                    <li><a href="#">tubes</a></li>
                    <li><a href="#">verre</a></li>
                  </ul>
                  <p>3 types de remplissage : les câbles en inox 316, les tubes en inox ou les panneaux de verre.</p>
                  <img src="/static/images/concept/remplissage.jpg" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="faq-pg-section section-padding-50" style="background-color: #051829;">
      <div class="container">
        <div class="row">
          <div class="col-md-12 text-center">
            <div class="possibities" style="font-size: 4rem;font-family: 'Montserrat', sans-serif;font-weight: bold;color: #fff;line-height: 50px;">
              <span style="color: #005e90;">=</span> 60 modèles au choix
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section-padding" style="padding: 25px 0 50px 0; position: relative;">
      <div class="container">
        <div class="row">
          <div class="col-xs-12">
            <div class="testimonials-slider slider-arrow-s1 owl-carousel">
              <div class="slide-item">
                <div class="inner col-center">
                  <img src="/static/images/concept/slider/img3d_2017090806095819961.jpg" alt="">
                  <div class="caption">
                    <span>Poteaux inox 304 / Rambarde inox / Panneaux de verre</span>
                  </div>
                </div>
              </div>
              <div class="slide-item">
                <div class="inner">
                  <img src="/static/images/concept/slider/img3d_2017090910462319964.jpg" alt="">
                  <div class="caption">
                    <span>Poteaux inox 316 / Rambarde bois / Remplissage câbles</span>
                  </div>
                </div>
              </div>
              <div class="slide-item">
                <div class="inner">
                  <img src="/static/images/concept/slider/garde-corps-inox-balcon.jpg" alt="">
                  <div class="caption">
                    <span>Poteaux inox 316 / Rambarde inox / Remplissage câbles</span>
                  </div>
                </div>
              </div>
              <div class="slide-item">
                <div class="inner">
                  <img src="/static/images/concept/slider/garde-corps-inox-droit.jpg" alt="">
                  <div class="caption">
                    <span>Poteaux inox 316 / Rambarde inox / Remplissage tubes</span>
                  </div>
                </div>
              </div>
              <div class="slide-item">
                <div class="inner">
                  <img src="/static/images/concept/slider/garde-corps-inox.jpg" alt="">
                  <div class="caption">
                    <span>Poteaux inox 316 / Rambarde inox / Remplissage tubes</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section-padding section-content bg-grey">
      <div class="container">
        <div class="row">
          <div class="col-md-8">
            <div class="row">
              <div class="col col-md-6">
                <div class="block">
                  <h2>Les garde-corps Oxynov :</h2>
                  <p>Oxynov® est un concept de <a href="/static/images/concept/zoom/rampe-escalier-rambarde-inox.jpg" class="zoom-concept" @click="openGallery('concept', $event)"><strong>garde-corps inox</strong></a><strong> en kit</strong> sur mesure à monter soi-même. Notre design contemporain s'adapte parfaitement à tous les environnements. <strong>Garde-corps intérieur ou extérieur</strong>, nous offrons toujours une solution adaptée à vos besoins.</p>
                </div>
                <div class="block">
                  <h2>Des produits de qualité :</h2>
                  <h3>Les poteaux inox :</h3>
                  <p>Les <strong><a href="/static/images/concept/zoom/visuel_poteaux_inox.jpg" class="zoom-concept" @click="openGallery('concept', $event)">poteaux</a></strong> sont livrés pré-montés et pré-équipés de 5 supports de <a href="/static/images/concept/zoom/garde-corps-inox-tube-inox-TUB002.jpg" class="zoom-concept" @click="openGallery('concept', $event)">tubes</a> ou <a href="/static/images/concept/zoom/garde-corps-inox-cables-CAB007.jpg" class="zoom-concept" @click="openGallery('concept', $event)">câbles</a>, avec leur platine de fixation et leur cache platine, ainsi que du <a href="/static/images/concept/zoom/main-courante-bois-support-d-angle-90-degres.jpg" class="zoom-concept" @click="openGallery('concept', $event)">support de main courante</a>. &nbsp;Toutes les opérations délicates sont réalisées en usine. En fonction de la nature de votre sol (bois ou béton) nous vous proposons la fixation adaptée (<a href="/static/images/concept/zoom/pot_tirefonds-inox-fixation-poteau-sur-sol-bois-TIR001.jpg" class="zoom-concept" @click="openGallery('concept', $event)">tirefonds</a> ou <a href="/static/images/concept/zoom/pot-chevilles-Inox-fixation-poteau-sur-sol-beton-CHE007.jpg" class="zoom-concept" @click="openGallery('concept', $event)">chevilles béton</a>).</p>
                  <h3>Les mains courantes :</h3>
                  <p>Les sections de <strong>main courante</strong> sont identiques pour le <a href="/static/images/concept/zoom/main-courante-bois-rambarde-MAI004.jpg" class="zoom-concept" @click="openGallery('concept', $event)">bois</a> et l'<a href="/static/images/concept/zoom/main-courante-inox-rambarde-MAI003.jpg" class="zoom-concept" @click="openGallery('concept', $event)">inox</a> : 42mm, par contre chaque modèle de rampe possède son propre système de raccords adaptés.</p>
                  <h3>Remplissage et décoration :</h3>
                  <ul>
                    <li>Les <a href="/static/images/concept/zoom/garde-corps-inox-cables-manchon-caoutchouc-MAN001.jpg" class="zoom-concept" @click="openGallery('concept', $event)">câbles</a> sont livrés à longueur fixe, ils sont à recouper sur chantier avec notre <a href="/static/images/concept/zoom/garde-corps-inox-cables-pince-coupe-cable.jpg" class="zoom-concept" @click="openGallery('concept', $event)">pince coupante</a>. Les câbles se fixent facilement dans les chapes de fixation serties en usine d'un côté (l'autre côté servant à accueillir le câble ou le tendeur à serrage manuel)</li>
                    <li>Les <a href="/static/images/concept/zoom/garde-corps-inox-tube-inox-PLA009.jpg" class="zoom-concept" @click="openGallery('concept', $event)">tubes</a> (de 12mm) sont livrés par 5 pièces de 2m de longueur. Ils se raccordent entre eux et s'articulent à l'aide de pièces de jonction adaptées (<a href="/static/images/concept/zoom/garde-corps-inox-tube-coude-articule-pour-tube-COU006.jpg" class="zoom-concept" @click="openGallery('concept', $event)">coude articulé</a> ou <a href="/static/images/concept/zoom/garde-corps-inox-tube-coude-articule-pour-tube-COU006.jpg" class="zoom-concept" @click="openGallery('concept', $event)">manchon de liaison</a>).</li>
                    <li>Le <a href="/static/images/concept/zoom/garde-corps-inox-tube-panneau-de-verre-acrylique-PAN001.jpg" class="zoom-concept" @click="openGallery('concept', $event)">panneau de verre en méthacrylate</a> est fourni en sur-mesure en fonction de votre devis. La hauteur du panneau est toujours de 45cm. Il se fixe sur les 3 barres inférieures (tubes) du garde-corps</li>
                  </ul>
                </div>
              </div>
              <div class="col col-md-6" style="border-left: dashed 1px #d4d4d4;">
                <div class="block">
                  <h2>Une multitude de combinaisons possibles :</h2>
                  <p>Combinez l'ensemble de nos éléments pour réaliser le modèle de votre choix&nbsp;: <strong>main courante en <a href="/static/images/concept/zoom/main-courante-bois-rambarde-MAI004.jpg" class="zoom-concept" @click="openGallery('concept', $event)">bois exotique</a> ou en <a href="/static/images/concept/zoom/main-courante-inox-rambarde-MAI003.jpg" class="zoom-concept" @click="openGallery('concept', $event)">inox</a></strong>, remplissage par <a href="/static/images/concept/zoom/garde-corps-inox-remplissage-cable-piscine2.jpg" class="zoom-concept" @click="openGallery('concept', $event)">câbles</a>, <a href="/static/images/concept/zoom/remplissage-tubes-garde-corps-2.jpg" class="zoom-concept" @click="openGallery('concept', $event)">tubes</a>, avec ou sans <a href="/static/images/concept/zoom/plaque-acrylique-transparente-pour-garde-corps.jpg" class="zoom-concept" @click="openGallery('concept', $event)">panneau de verre</a> en méthacrylate, fixation à la française (<a href="/static/images/concept/zoom/pot-poteau_inox_fixation_a_plat_POT020.jpg" class="zoom-concept" @click="openGallery('concept', $event)">à plat</a>) ou à l'anglaise (<a href="/static/images/concept/zoom/pot-poteau_inox_fixation_laterale_POT021.jpg" class="zoom-concept" @click="openGallery('concept', $event)">latérale</a>). Vous pouvez visualiser nos principaux modèles de garde-corps en cliquant sur la rubrique « Modèles » du menu.</p>
                  <p><strong>Le concept Oxynov® s'adapte à toutes les configurations et offre toujours une solution à mettre en œuvre facilement et rapidement. </strong></p>
                  <p>Toutes nos solutions sont faciles à monter soi-même !</p>
                </div>
                <div class="block">
                  <h2>Utilisation du matériel :</h2>
                  <p>Les produits OXYNOV sont fabriqués, emballés, stockés et expédiés avec le plus grand soin. Afin d'en préserver l'aspect initial, nous vous recommandons de suivre scrupuleusement les consignes de montage et d'entretien.</p>
                  <ul>
                    <li>
                      <h3>Inox 304</h3>
                      <p>L'inox 304 est à utiliser à l'intérieur ainsi qu'à l'extérieur. Ne convient pas dans une atmosphère polluée (Zone industrielle – portuaire – étables – piscine). Eloignement d'au moins 50km des côtes, taux d'humidité bas.</p>
                    </li>
                    <li>
                      <h3>Inox 316</h3>
                      <p>L'Inox 316 est indispensable à l'extérieur, si le produit est exposé à des intempéries ou installé en milieu agressif (bord de mer, zone industrielle, piscine…) Dans ces milieux, sans utilisation d'inox 316, des taches de rouille peuvent apparaître. (Déconseillé en milieux chlorés et iodés.)</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4" style="border-left: dashed 1px #d4d4d4;">
            <Aside/>
          </div>
        </div>
      </div>
    </section>
    <section class="section-padding" style="padding-top: 0;padding-bottom: 50px;">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <tabs :options="{ useUrlFragment: false }" style="margin-top: -43px;">
              <tab name="Main courante bois" style="padding-top: 50px;">
                <div class="row">
                  <div class="col-md-8 col-md-offset-2">
                    <div class="product-tour">
                      <img src="/static/images/concept/products/bois/garde-corps-bois-min.jpg" alt="Garde-corps bois" class="img-responsive">
                      <ul>
                        <li id="bois-feature-1" :class="{ active: activeTips.bois.indexOf(0) >= 0 }">
                         <v-popover :placement="'left'" :offset="4" style="position: absolute; z-index: 112" @show="toggleActive(0, 'bois')">
                            <button class="btn btn-link"></button>
                            <template slot="popover">
                              <div class="item">
                                <div class="item-title">
                                  <strong>Platine murale inox</strong>
                                  pour main courante
                                </div>
                                <img src="/static/images/concept/products/bois/garde-corps-bois-detail-7-min.jpg" alt="">
                              </div>
                            </template>
                          </v-popover>
                        </li>
                        <li id="bois-feature-2" :class="{ active: activeTips.bois.indexOf(1) >= 0 }">
                          <v-popover :placement="'bottom'" :offset="4" style="position: absolute; z-index: 112" @show="toggleActive(1, 'bois')">
                            <button class="btn btn-link"></button>
                            <template slot="popover">
                              <div class="item">
                                <div class="item-title">
                                  <strong>Gabarit de percage</strong>
                                  pour main courante Ø 42mm (1pc)
                                </div>
                                <img src="/static/images/concept/products/bois/garde-corps-bois-detail-3-min.jpg" alt="">
                              </div>
                              <div class="item">
                                <div class="item-title">
                                  <strong>Inserts de liaison</strong>
                                  pour main courante 42mm (2pcs)
                                </div>
                                <img src="/static/images/concept/products/bois/garde-corps-bois-detail-1-min.jpg" alt="">
                              </div>
                              <div class="item">
                                <div class="item-title">
                                  <strong>Manchon inox de liaison</strong>
                                  pour main courante 42mm (1pc)
                                </div>
                                <img src="/static/images/concept/products/bois/garde-corps-bois-detail-2-min.jpg" alt="">
                              </div>
                            </template>
                          </v-popover>
                        </li>
                        <li id="bois-feature-3" :class="{ active: activeTips.bois.indexOf(2) >= 0 }">
                          <v-popover :placement="'bottom'" :offset="4" style="position: absolute; z-index: 112" @show="toggleActive(2, 'bois')">
                            <button class="btn btn-link"></button>
                            <template slot="popover">
                              <div class="item">
                                <div class="item-title">
                                  <strong>Coude inox articulé</strong>
                                  pour main courante Ø 42mm (1pc)
                                </div>
                                <img src="/static/images/concept/products/bois/garde-corps-bois-detail-6-min.jpg" alt="">
                              </div>
                              <div class="item">
                                <img src="/static/images/concept/products/bois/garde-corps-bois-detail-5-min.jpg" alt="">
                              </div>
                              <div class="item">
                                <img src="/static/images/concept/products/bois/garde-corps-bois-detail-4-min.jpg" alt="">
                              </div>
                            </template>
                          </v-popover>
                        </li>
                        <li id="bois-feature-4" :class="{ active: activeTips.bois.indexOf(3) >= 0 }">
                          <v-popover :placement="'bottom'" :offset="4" style="position: absolute; z-index: 112" @show="toggleActive(3, 'bois')">
                            <button class="btn btn-link"></button>
                            <template slot="popover">
                              <div class="item">
                                <div class="item-title">
                                  <strong>Main courante en bois exotique</strong>
                                  HETRE / IROKO / IPE Ø 42mm (1pc) longueur 2m30 (1pc)
                                </div>
                                <img src="/static/images/concept/products/bois/main-courante-bois-exo2-min.jpg" alt="">
                              </div>
                              <div class="item">
                                <img src="/static/images/concept/products/bois/mc-bois-min.jpg" alt="">
                              </div>
                            </template>
                          </v-popover>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 text-center">
                    <h3>Garde-corps Inox à main courante en bois</h3>
                    <p style="font-style: italic;">Passez votre souris pour visualiser le détail du produit</p>
                  </div>
                </div>
              </tab>
              <tab name="Main courante inox" style="padding-top: 50px;">
                <div class="row">
                  <div class="col-md-8 col-md-offset-2">
                    <div class="product-tour">
                      <img src="/static/images/concept/products/inox/garde-corps-inox-min.jpg" alt="Garde-corps inox" class="img-responsive">
                      <ul>
                        <li id="inox-feature-1" :class="{ active: activeTips.inox.indexOf(0) >= 0 }">
                         <v-popover :placement="'left'" :offset="4" style="position: absolute; z-index: 112" @show="toggleActive(0, 'inox')">
                            <button class="btn btn-link"></button>
                            <template slot="popover">
                              <div class="item">
                                <div class="item-title">
                                  <strong>Platine murale inox</strong>
                                  pour main courante Ø 42mm (1pc)
                                </div>
                                <img src="/static/images/concept/products/inox/garde-corps-inox-detail-7-min.jpg" alt="">
                              </div>
                            </template>
                          </v-popover>
                        </li>
                        <li id="inox-feature-2" :class="{ active: activeTips.inox.indexOf(1) >= 0 }">
                         <v-popover :placement="'top'" :offset="4" style="position: absolute; z-index: 112" @show="toggleActive(1, 'inox')">
                            <button class="btn btn-link"></button>
                            <template slot="popover">
                              <div class="item">
                                <div class="item-title">
                                  <strong>Manchon inox de liaison</strong>
                                  pour main courante Ø 42mm (1pc)
                                </div>
                                <img src="/static/images/concept/products/inox/garde-corps-inox-detail-1-min.jpg" alt="">
                              </div>
                            </template>
                          </v-popover>
                        </li>
                        <li id="inox-feature-3" :class="{ active: activeTips.inox.indexOf(2) >= 0 }">
                         <v-popover :placement="'left'" :offset="4" style="position: absolute; z-index: 112" @show="toggleActive(2, 'inox')">
                            <button class="btn btn-link"></button>
                            <template slot="popover">
                              <div class="item">
                                <div class="item-title">
                                  <strong>Coude articulé</strong>
                                  pour main courante Ø 42mm (1pc)
                                </div>
                                <img src="/static/images/concept/products/inox/garde-corps-inox-detail-3-min.jpg" alt="">
                              </div>
                              <div class="item">
                                <img src="/static/images/concept/products/inox/garde-corps-inox-detail-4-min.jpg" alt="">
                              </div>
                              <div class="item">
                                <img src="/static/images/concept/products/inox/garde-corps-inox-detail-5-min.jpg" alt="">
                              </div>
                            </template>
                          </v-popover>
                        </li>
                        <li id="inox-feature-4" :class="{ active: activeTips.inox.indexOf(3) >= 0 }">
                         <v-popover :placement="'right'" :offset="4" style="position: absolute; z-index: 112" @show="toggleActive(3, 'inox')">
                            <button class="btn btn-link"></button>
                            <template slot="popover">
                              <div class="item">
                                <div class="item-title">
                                  <strong>Main courante inox</strong>
                                  Ø 42mm / longueur 2m (1pc)
                                </div>
                                <img src="/static/images/concept/products/inox/main-courante-inox-min.jpg" alt="">
                              </div>
                              <div class="item">
                                <img src="/static/images/concept/products/inox/main-courante-inox-2-min.jpg" alt="">
                              </div>
                            </template>
                          </v-popover>
                        </li>
                        <li id="inox-feature-5" :class="{ active: activeTips.inox.indexOf(4) >= 0 }">
                         <v-popover :placement="'right'" :offset="4" style="position: absolute; z-index: 112" @show="toggleActive(4, 'inox')">
                            <button class="btn btn-link"></button>
                            <template slot="popover">
                              <div class="item">
                                <div class="item-title">
                                  <strong>Embout pour main courante inox</strong>
                                  Ø 42mm (1pc)
                                </div>
                                <img src="/static/images/concept/products/inox/garde-corps-inox-detail-6-min.jpg" alt="">
                              </div>
                            </template>
                          </v-popover>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 text-center">
                    <h3>Garde-corps Inox à main courante en inox</h3>
                    <p style="font-style: italic;">Passez votre souris pour visualiser le détail du produit</p>
                  </div>
                </div>
              </tab>
            </tabs>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
/* global $ */
import 'owl.carousel/dist/assets/owl.carousel.min.css'
import 'owl.carousel'
import Aside from '../Aside'

export default {
  name: 'Concept',
  components: { Aside },
  data () {
    return {
      activeTips: {
        bois: [0, 1, 2, 3],
        inox: [0, 1, 2, 3, 4]
      }
    }
  },
  methods: {
    openGallery (id, event) {
      /* eslint-disable */
      event = event || window.event;
      var target = event.target || event.srcElement,
        link = target.src ? target.parentNode : target,
        options = {index: link, event: event},
        links = document.getElementById(id).querySelectorAll('a.zoom-concept');
      blueimp.Gallery(links, options);
      event.preventDefault()
    },
    toggleActive (index, group) {
      if (this.activeTips[group][index] >= 0) {
        this.activeTips[group].splice(index, 1);
      }
    }
  },
  mounted () {
    $('.testimonials-slider').owlCarousel({
      autoplay: true,
      mouseDrag: true,
      smartSpeed: 1000,
      loop: true,
      autoplayHoverPause: true,
      items: 1,
      dots: true,
      nav: true,
      navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>']
    })
  }
}
</script>

<style scoped>
h1 {
  margin-bottom: 50px;
}
h1 div {
  color: #025d90;
}
.service-s2-box-grids .grid .inner {
  border: 2px solid #6A8590;
  border-top-right-radius: 15px;
}
.service-s2-box-grids .inner h3 {
  text-transform: uppercase;
}
.service-s2-box-grids .grid {
  padding: 0 30px;
  position: relative;
}
.service-s2-box-grids .grid:after {
  content: '+';
  position: absolute;
  top: 50%;
  right: 0;
  font-size: 40px;
  margin-top: -28.5px;
  margin-right: -11px;
}
.service-s2-box-grids .grid:hover .inner {
  border-color: #025d90;
  box-shadow: 0 2px 5px 0 rgba(0,0,0,.26);
}
.service-s2-box-grids .grid:hover .inner > img {
  border-color: #025d90;
}
.service-s2-box-grids .grid:last-child:after {
  content: unset;
}
.service-s2-box-grids .inner {
  position: relative;
  background-color: #fff;
}
.service-s2-box-grids .inner > img {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 75px;
  border: solid 2px #698490;
  border-bottom: 0;
  border-left: 0;
  border-top-right-radius: 15px;
}
.egual {
  font-weight: 600;
  position: relative;
}
.egual > span {
  font-size: 4rem;
  font-weight: bold;
  position: absolute;
  left: -34px;
  top: -0;
  color: #fff;
}
.egual > span:before {
  content: "";
  background-color: #005e90;
  width: 2px;
  height: 112%;
  position: absolute;
  left: 50%;
  top: -10px;
  transform: rotate(40deg);
}
.tags {
  list-style: none;
  display: inline-block;
}
.tags li {
  float: left;
  margin: 0 2px;
}
.tags li:after {
  content: '/';
  margin-left: 3px;
  color: #777;
}
.tags li:last-child:after {
  content: unset;
}
.tags li a {
  background: #025d90;
  line-height: 10px;
  display: inline-block;
  padding: 4px 5px 2px 5px;
  color: #fff;
  text-transform: uppercase;
  font-size: 80%;
  border-radius: 2px;
}
.testimonials-slider .slide-item:before {
  content: unset;
}
.testimonials-slider .caption {
  position: absolute;
  bottom: 0;
  background: rgb(5, 24, 42);
  padding: 5px 15px;
  border-radius: 50px;
  width: 390px;
  left: 50%;
  margin-left: -195px;
}
.testimonials-slider .caption span {
  color: #fff;
}
.product-tour {
  position: relative;
}
.product-tour ul {
  list-style: none;
}
.product-tour ul li {
  position: absolute;
  width: 50px;
  height: 50px;
  background: transparent;
  border: solid 3px #045c90;
  cursor: zoom-in;
  border-radius: 50%;
  transform: scale(1);
}
.product-tour ul li:after {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  border-radius: inherit;
}
.product-tour ul li.active:after {
  transform: translateZ(0);
  backface-visibility: hidden;
  animation: cd-pulse 2s infinite;
  animation-delay: .5s;
}
.product-tour li .btn-link {
  height: 44px;
  width: 44px;
}
.product-tour li .btn-link:focus {
  outline: none;
}
.product-tour .item-title {
  
}
.product-tour #bois-feature-1,
.product-tour #inox-feature-1 {
  top: 13px;
  left: 20px;
}
.product-tour #bois-feature-2,
.product-tour #inox-feature-2 {
  top: 18px;
  left: 218px;
}
.product-tour #bois-feature-3,
.product-tour #inox-feature-3 {
  top: 22px;
  left: 411px;
}
.product-tour #bois-feature-4,
.product-tour #inox-feature-4 {
  top: 162px;
  left: 562px;
}
.product-tour #inox-feature-5 {
  top: 261px;
  left: 661px;
}
@keyframes cd-pulse {
  0% {
    box-shadow: 0 0 0 0 #025d90;
  }
  100% {
    box-shadow: 0 0 0 20px rgba(2, 93, 144, 0);
  }
}
</style>
<style>
.testimonials-slider .owl-dots {
  text-align: center;
  margin-top: 50px;
}
.testimonials-slider .owl-dot {
  height: 4px;
  background: #698490!important;
  width: 20px;
  margin: 0 2px;
}
.testimonials-slider .owl-dot:focus {
  outline: none;
}
.testimonials-slider .owl-dot.active {
  background: #005e90!important;
}
.testimonials-slider .owl-nav {
  position: absolute;
  top: 50%;
  width: 100%;
  margin-top: -40px;
}
.owl-prev, .owl-next {
  position: absolute;
}
.owl-prev:focus, .owl-next:focus {
  outline: none;
}
.owl-prev:hover i, .owl-next:hover i {
  color: #005e90;
}
.owl-prev i, .owl-next i {
  font-size: 80px;
  color: #698490;
}
.owl-next {
  right: 0;
}
</style>

<style lang="scss">
.tooltip {
  display: block !important;
  z-index: 10000;

  .tooltip-inner {
    background: black;
    color: white;
    border-radius: 16px;
    padding: 5px 10px 4px;
  }

  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: black;
    z-index: 1;
  }

  &[x-placement^="top"] {
    margin-bottom: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="bottom"] {
    margin-top: 5px;

    .tooltip-arrow {
      border-width: 0 5px 5px 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="right"] {
    margin-left: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 5px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[x-placement^="left"] {
    margin-right: 5px;

    .tooltip-arrow {
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &.popover {
    $color: #f9f9f9;

    .popover-inner {
      background: #FFF;
      color: black;
      padding: 10px;
      border-radius: 5px;
      box-shadow: 0 5px 30px rgba(black, .1);
    }

    .popover-arrow {
      border-color: $color;
    }
    .item {
      border-bottom: dashed 1px #d4d4d4;
      margin-bottom: 20px;
      
      &:last-child {
        margin: 0;
        border: 0;
      }
      
      .item-title {
        font-size: 11px;
      }
      
      strong {
        display: block;
        font-size: 12px;
        text-transform: uppercase;
      }
      img {
        width: 100px;
        margin: 0 auto;
        display: block;
      }
    }
  }

  &[aria-hidden='true'] {
    visibility: hidden;
    opacity: 0;
    transition: opacity .15s, visibility .15s;
  }

  &[aria-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transition: opacity .15s;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Pages/Concept.vue